export { default } from './SignUpBusinessView'
